import onUcmaNotification from './onUcmaNotification';
import mountChatTabBar from '../components/ChatTabBar';
import dispatchPresenceUpdateFromHeader from '../presenceManager/dispatchPresenceUpdateFromHeader';
import signInIM, { SignInType } from '../presenceManager/signInIM';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import { trace } from 'owa-trace';

let isNotificationSubscribed = false;
let isPresenceSubscribed = false;

export default function initializeUcma() {
    // first, we need to hook into presence updates
    const o365shell: IO365ShellShim = (window as any).O365Shell;
    if (
        o365shell &&
        o365shell.MeControl &&
        o365shell.MeControl.SubscribeToPresenceStatus &&
        !isPresenceSubscribed
    ) {
        o365shell.MeControl.SubscribeToPresenceStatus((key: string) => {
            dispatchPresenceUpdateFromHeader(key as InstantMessagePresenceType);
        });
        isPresenceSubscribed = true;
    } else {
        if (!isPresenceSubscribed) {
            isPresenceSubscribed = true;
            trace.error(
                'OwaUCMAPresenceManagerError: Missing SubscribeToPresenceStatus or suite header failed to initialize.'
            );
        }
    }
    if (!isNotificationSubscribed) {
        const subscription: NotificationSubscription = {
            subscriptionId: 'InstantMessageNotification',
            requiresExplicitSubscribe: true,
            subscriptionParameters: {
                NotificationType: 'InstantMessageNotification',
            },
        };
        lazySubscribe.importAndExecute(subscription, onUcmaNotification).then(() => {
            isNotificationSubscribed = true;
            signInIM(SignInType.Auto);
        });
    } else {
        signInIM(SignInType.Auto);
    }

    mountChatTabBar();
}
